export default __webpack_public_path__ + "static/media/mobile_phone.06a36781.svg";